import React, {useContext, useEffect, useState} from 'react';
import {DispatchContext, StateContext} from '../../../store';
import Box from '@mui/material/Box';
import {Button} from '@mui/material';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import ClearIcon from '@mui/icons-material/Clear';
import DownloadDoneRoundedIcon from '@mui/icons-material/DownloadDoneRounded';
import ReplyIcon from '@mui/icons-material/Reply';
import {acquisitionsTaskPoolService} from '../../../services/AcquisitionServices';
import {taskPoolServices} from '../../../services/TaskPoolServices';
import {SNACKBAR_OPEN} from '../../../reducers';
import ApproveAcquisition from './ApproveAcquisition';
import RejectAcquisition from './RejectedAcquisition';
import ForwardAcquisition from './ForwardAcquisition';

export default function AcquisitionDetailActions({item, handleEdit, acquisitionId}) {
  const dispatch = useContext(DispatchContext);
  const {role} = useContext(StateContext);
  const {commonUpdate} = useContext(StateContext);
  const [taskPool, setTaskPool] = useState([]);
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [display, setDisplay] = useState(false);
  const isAdminOrChief = role?.id === 1 || role?.id === 10;
  const roleAssistant = role?.id === 3;
  const roleCurator = role?.id === 2;
  const roleCuratorAdmin = role?.id === 2 || isAdminOrChief;
  const roleAdmin = isAdminOrChief;
  const requested = item?.state === 'requested';
  const forwardedToAdmin = item?.state === 'forwarded_to_admin';
  const rejected = item?.state === 'rejected';
  const approved = item?.state === 'approved';
  const resubmitted = item?.state === 'resubmitted';
  const poolId = taskPool?.map(value => value?.role_id);
  const roleId = role?.id;

  const isRoleIdInPool = poolId.includes(roleId);

  let taskPoolId = null;
  let taskPoolState = '';

  if (isRoleIdInPool) {
    const index = poolId.indexOf(roleId);

    if (index !== -1) {
      taskPoolId = taskPool[index]?.id;
      taskPoolState = taskPool[index]?.state;
    }
  }

  useEffect(() => {
    getTaskPool();
  }, [commonUpdate]);

  const getTaskPool = () => {
    acquisitionsTaskPoolService('get', acquisitionId).then(res => {
      setTaskPool(res?.data);
    })
  }

  const handleReject = () => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleAcceptAction = () => {
    setDisplay(true);
  }

  const handleCloseAction = () => {
    setDisplay(false);
  }

  const handleOpenAction = () => {
    setShow(true);
  }

  const handleExitAction = () => {
    setShow(false);
  }

  const handleStartPool = () => {
    taskPoolServices('put', taskPoolId, {action: 'start'}).then(res => {
      dispatch({type: 'STATE', payload: {change: true}});
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Started successfully'}
      });
    });
  }

  return (
    <>
      {item?.state &&
      <div>
        {(roleAssistant && requested) ? (
          <Box>
            <Button variant={'contained'} className={'shadow-none no-cursor'}
                    sx={{mr: 2, bgcolor: '#FF965B', '&:hover': {bgcolor: '#FF965B'}}}>Pending</Button>
          </Box>) : (roleAssistant && rejected) ? (
          <Box>
            <Button variant={'contained'} className={'shadow-none no-cursor'}
                    sx={{mr: 2, bgcolor: '#f6363c', '&:hover': {bgcolor: '#F6363C'}}}>Rejected</Button>
            <Button onClick={handleEdit}
                    startIcon={<BorderColorRoundedIcon/>} variant={'contained'}
                    sx={{mr: 2, bgcolor: '#009344'}}>Resubmit</Button>
          </Box>) : (roleAssistant && approved) ? (
          <Box>
            <Button variant={'contained'} className={'shadow-none no-cursor'}
                    sx={{mr: 2, bgcolor: '#009344', '&:hover': {bgcolor: '#009344'}}}>Approved</Button>
          </Box>
        ) : <div/>}
        {taskPoolState === 'in_progress' ?
          <div>
            {((roleCuratorAdmin && (requested || forwardedToAdmin)) || (roleCuratorAdmin && resubmitted)) ? (
              <Box>
                <Button onClick={handleEdit}
                        startIcon={<BorderColorRoundedIcon/>} variant={'contained'}
                        sx={{mr: 2, bgcolor: '#009344'}}>Edit</Button>
                <Button onClick={handleReject} startIcon={<ClearIcon/>} variant={'contained'} color={'error'}
                        sx={{mr: 2}}>Reject</Button>
                {roleAdmin &&
                <Button onClick={handleAcceptAction} startIcon={<DownloadDoneRoundedIcon/>}
                        variant={'contained'}>Approve</Button>
                }
                {roleCurator &&
                <Button onClick={handleOpenAction} startIcon={<ReplyIcon/>} variant={'contained'}>
                  Forward to Admin
                </Button>
                }
              </Box>
            ) : (roleCuratorAdmin && rejected) ? (
              <Box>
                <Button variant={'contained'} className={'shadow-none no-cursor'}
                        sx={{mr: 2, bgcolor: '#f6363c', '&:hover': {bgcolor: '#F6363C'}}}>Rejected</Button>
              </Box>
            ) : (roleCuratorAdmin && approved) ? (
              <Box>
                <Button variant={'contained'} className={'shadow-none no-cursor'}
                        sx={{mr: 2, bgcolor: '#009344', '&:hover': {bgcolor: '#009344'}}}>Approved</Button>
              </Box>
            ) : <div/>}
          </div> :
          <div>
            {roleCuratorAdmin && (taskPoolState === 'in_progress' || taskPoolState === 'assigned') ?
              <Button onClick={handleStartPool} variant={'contained'} sx={{ml: 2}}>
                Start
              </Button> :
              <div>
                {taskPoolState &&
                <div>
                  {taskPoolState === 'completed' ?
                    <Button variant={'contained'} className={'shadow-none no-cursor'}
                            sx={{mr: 2, bgcolor: '#009344', '&:hover': {bgcolor: '#009344'}}}>Completed</Button> :
                    <Button variant={'contained'} className={'shadow-none no-cursor'}
                            sx={{mr: 2, bgcolor: '#FF965B', '&:hover': {bgcolor: '#FF965B'}}}>Pending</Button>
                  }
                </div>}
              </div>
            }
          </div>
        }
      </div>
      }
      {(roleAssistant && resubmitted) &&
      <Button variant={'contained'} className={'shadow-none no-cursor'}
              sx={{mr: 2, bgcolor: '#009344', '&:hover': {bgcolor: '#009344'}}}>Resubmitted</Button>
      }
      {show &&
      <ForwardAcquisition open={show} handleAction={handleExitAction} acquisitionId={acquisitionId}/>}
      {open &&
      <RejectAcquisition open={open} handleAction={handleClose} roleId={roleId} taskPool={taskPool}/>}
      {display &&
      <ApproveAcquisition open={display} handleAction={handleCloseAction} roleId={roleId} taskPool={taskPool}/>}
    </>
  );
}